<script setup lang="ts">

  const props = withDefaults(defineProps<{
    modal?: 'dialog' | 'drawer',
    showFooter?: boolean
  }>(), {
    modal: 'dialog',
    showFooter: false
  })

  const baseConfig = reactive({
    isOpen: false,
    confirmLoading: false
  })

  const isOpen = defineModel({ default: false })

  function open() {
    isOpen.value = true
  }

  function close() {
    isOpen.value = false
  }

  function handleOk() {

  }
</script>

<template>
  <div class="base-dialog">
    <a-modal v-model:open="isOpen" :footer="!props.showFooter? null: true" @ok="handleOk" :confirm-loading="baseConfig.confirmLoading" v-bind="$attrs">
      <slot name="default"></slot>
    </a-modal>
  </div>
</template>

<style scoped lang="scss">

</style>